import styled from '@emotion/styled';
import { nafColor } from '@nafcore/theme';
import { spacing } from '@naf/theme';
import { Text } from '@naf/text';

export const BlockWrapper = styled.ul`
  margin-bottom: ${spacing.space24};
  padding: 0;
`;

export const ListItem = styled.li`
  list-style-type: none;
`;

export const InfoText = styled(Text)`
  display: flex;
  align-items: center;
`;

export const DotIcon = styled.span`
  height: 4px;
  width: 4px;
  background-color: ${nafColor.neutral.neutral4};
  border-radius: 50%;
  display: inline-block;
  margin: 0 ${spacing.space8} 0 ${spacing.space8};
`;

export const DocumentItemWrapper = styled.a`
  display: flex;
  width: 100%;
  justify-content: space-between;
  padding: 0 0 ${spacing.space16} 0;
  border-bottom: 1px solid ${nafColor.neutral.neutral2};
  margin-bottom: ${spacing.space16};
  cursor: pointer;
  text-decoration: none;
  align-items: start;
  svg {
    padding-top: ${spacing.space4};
    width: 18px;
    height: 18px;
  }
`;

export const DocumentText = styled.div`
  display: flex;
  align-items: start;
  svg {
    padding-top: 0;
    margin-right: ${spacing.space20};
    width: 32px;
    height: 32px;
  }
  img {
    margin-right: ${spacing.space20};
  }
`;

export const DocumentHeader = styled(Text)`
  margin: 0 !important;
`;
